export default __webpack_public_path__ + "static/media/books-1920w.10c6a54a.avif";